import { RuleResult } from 'types/DeclarationP5'

const C0599Validator = {
  validateModeOfTransportAtBorderRequirement: ({
    security,
    additionalDeclarationType,
  }: {
    security: string
    additionalDeclarationType: string
  }): RuleResult => {
    if (['1', '2', '3'].includes(security) && additionalDeclarationType === 'A') {
      return 'REQUIRED'
    }

    return 'OPTIONAL'
  },
} as const

export default C0599Validator
